import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Amount } from '@welldev-group/react-comp-lib';
import SubscriptionModeSwitch from '../SubscriptionModeSwitch';

const NewPlanDetails = ({
  className,
  plan,
  period,
  onSubscriptionPeriodChange,
  hidePeriodToggler,
  disableToggle,
  toggleDisabilityReasonText,
}) => {
  const isFree = parseFloat(plan?.price) <= 0;
  const isYearly = period === 'yearly';
  const isMonthly = period === 'monthly';

  return (
    <div className={classNames('new-plan-details', className)}>
      <div className="new-plan-details__info">
        <div className="new-plan-details__info-sub-title">Selected Plan</div>
        {plan ? (
          <div className="new-plan-details__info-title">
            {I18n.t(plan.name, {
              scope: 'components.plans',
            })}{' '}
            -{' '}
            <Amount
              minFractionDigit={2}
              currency={plan.currency_code}
              value={plan.price || ''}
              returnStringOnly={true}
            />
          </div>
        ) : null}
        <div className="new-plan-details__info-period-details">
          {isFree && I18n.t('components.subscription.free_price_text')}
          {!isFree &&
            isMonthly &&
            I18n.t('components.subscription.per_month_price_text')}
          {!isFree &&
            isYearly &&
            I18n.t('components.subscription.per_year_price_text')}
        </div>
      </div>
      {!hidePeriodToggler ? (
        <div className="new-plan-details__mode-change">
          <SubscriptionModeSwitch
            flippedHorizontaly={true}
            subscribeYearly={isYearly}
            onModeChange={onSubscriptionPeriodChange}
            disabled={disableToggle}
            disabilityReasonText={toggleDisabilityReasonText}
          />
        </div>
      ) : null}
    </div>
  );
};

NewPlanDetails.defaultProps = {
  className: '',
  hidePeriodToggler: false,
  plan: null,
  period: () => {},
  onSubscriptionPeriodChange: () => {},
  disableToggle: true,
  toggleDisabilityReasonText: '',
};

NewPlanDetails.propTypes = {
  className: PropTypes.string,
  plan: PropTypes.shape({
    name: PropTypes.string,
    price: PropTypes.string,
    currency_code: PropTypes.string,
  }),
  period: PropTypes.string,
  hidePeriodToggler: PropTypes.bool,
  onSubscriptionPeriodChange: PropTypes.func,
  disableToggle: PropTypes.bool,
  toggleDisabilityReasonText: PropTypes.string,
};

export default NewPlanDetails;
